module.exports = __webpack_public_path__ + "img/matchmallow.0f4a7702.jpeg";